import { BadgeCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';

const ApprovalsIcon = () => (
	<Button
		variant="outline"
		size="xs"
		className="rounded-full text-yellow-600 border-yellow-600 hover:bg-yellow-600 hover:text-white"
	>
		<BadgeCheck className="w-5 h-5 inherit" />
		<span className="screen-reader-text">Approval Icon</span>
	</Button>
);

export default ApprovalsIcon;
